import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class OfferDetailsService {

  constructor(private http: HttpClient) { }
  api_url = environment.SERVER_URL + 'icrweb/home/'

  getPreOfferDetails(obj = {}) {
    obj['sellerShortCode'] = localStorage.getItem('sellerShortCode') || environment.SHORTCODE;
    return this.http.post(this.api_url + 'get_myjourney_pre_offer_doc_details', obj)
  }

  getPreOfferMasters(obj = {}) {
    obj['sellerShortCode'] = localStorage.getItem('sellerShortCode') || environment.SHORTCODE;
    return this.http.post(this.api_url + 'get_portal_myjourney_master_data', obj)
  }

  submitPreOfferDetails(obj = {}) {
    obj['sellerShortCode'] = localStorage.getItem('sellerShortCode') || environment.SHORTCODE;
    return this.http.post(this.api_url + 'submit_myjourney_pre_offer_doc_data', obj)
  }

  getOfferDetails(obj = {}) {
    obj['sellerShortCode'] = localStorage.getItem('sellerShortCode') || environment.SHORTCODE;
    return this.http.post(this.api_url + 'get_myjourney_offer_acceptance_details', obj)
  }

  submitOfferAcceptance(obj = {}) {
    obj['sellerShortCode'] = localStorage.getItem('sellerShortCode') || environment.SHORTCODE;
    return this.http.post(this.api_url + 'submit_myjourney_offer_acceptance', obj)
  }

  getFeedbackQuestions(obj = {}) {
    obj['sellerShortCode'] = localStorage.getItem('sellerShortCode') || environment.SHORTCODE;
    return this.http.post(this.api_url + 'get_myjourney_onboarding_applicant_feedback', obj)
  }

  submitFeedbackAnswers(obj = {}) {
    obj['sellerShortCode'] = localStorage.getItem('sellerShortCode') || environment.SHORTCODE;
    return this.http.post(this.api_url + 'save_myjourney_onboarding_applicant_feedback', obj)
  }

  submitOnboardingDetails(request) {
    return this.http.post(this.api_url + 'submit_myjourney_onboarding_form_details', request);
  }

}
